export const USERS_MERCHANT_APPLICATION = "/MerchantApplication/GetUsersMerchantApplication"
export const MERCHANT_APPLICATION_INSERT = "/MerchantApplication/InsertMerchantApplication"
export const USER_CAN_MAKE_APPLICATION = "/MerchantApplication/GetUserCanMakeApplication"
export const USER_CAN_APPROVE_AGREEMENT = "/MerchantApplication/GetUserCanApproveAgreement"
export const APPROVE_MERCHANT_AGREEMENT = "/MerchantApplication/ApproveMerchantAgreement"
export const UPLOAD_MERCHANT_FILE = "/Asist/CreateCustomerDocument"
export const UPLOAD_MERCHANT_FILE_LIST = "/Asist/CreateCustomerDocumentList"
export const DELETE_MERCHANT_FILE = "/Asist/DeleteCustomerDocument"
export const GET_MERCHANT_FILE_SUBMERCHANTID = "/Asist/GetCustomerDocumentBySubMerchantId"
export const GET_MERCHANT_APPLICATION_DOCUMENT = "/MerchantApplication/GetApplicationDocumentByGuid"